import Api from '@/api'
const resource = 'risk_survey'

export default {
  fetchQuestions () {
    return Api.get(`/${resource}`)
  }
}
